module.exports = __webpack_public_path__ + "static/media/1001688.598d9177.jpg";